import moment from 'moment';

const dateTimeFormat = {
  sameDay: '[today at] LT',
  nextDay: '[tomorrow at] LT',
  nextWeek: 'dddd [at] LT',
  lastDay: '[yesterday at] LT',
  lastWeek: 'LT, D MMM YYYY',
  sameElse: 'LT, D MMM YYYY',
};

const dateOnlyFormat = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'dddd',
  lastDay: '[Yesterday]',
  lastWeek: 'D MMM YYYY',
  sameElse: 'D MMM YYYY',
};

type DateFormatType = 'dateOnly' | 'dateTimeStamp' | 'utc';

export default function formatDate(date: moment.MomentInput, format?: DateFormatType) {
  const d = moment(date);

  switch (format) {
    case 'dateOnly':
      return d.calendar(dateOnlyFormat);
    case 'dateTimeStamp':
      return d.format('h:mma, D MMM YYYY');
    case 'utc':
      return d.utc().format('YYYY-MM-DD HH:MM:ss UTC');
    default:
      return d.calendar(dateTimeFormat);
  }
}
